/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VehicleItemApiFrom } from '../../models/vehicle-item-api-from';

export interface ApiV3ServiceListVehicleGet$Plain$Params {

/**
 * Interface language
 */
  lang?: string;
}

export function apiV3ServiceListVehicleGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceListVehicleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VehicleItemApiFrom>>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceListVehicleGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VehicleItemApiFrom>>;
    })
  );
}

apiV3ServiceListVehicleGet$Plain.PATH = '/api/v3/service/ListVehicle';
